import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

const GLOBAL_SCROLLBAR_COLOR = '#01274d';
const GLOBAL_SCROLLBAR_TRACK_COLOR = '#d9e1ea';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollbarColor: `${GLOBAL_SCROLLBAR_COLOR} ${GLOBAL_SCROLLBAR_TRACK_COLOR}`,
        },
        body: {
          scrollbarColor: `${GLOBAL_SCROLLBAR_COLOR} ${GLOBAL_SCROLLBAR_TRACK_COLOR}`,
        },
        '*': {
          scrollbarWidth: 'auto',
          scrollbarColor: `${GLOBAL_SCROLLBAR_COLOR} ${GLOBAL_SCROLLBAR_TRACK_COLOR}`,
        },
        '*::-webkit-scrollbar': {
          width: '16px',
          height: '16px',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: GLOBAL_SCROLLBAR_COLOR,
          borderRadius: '10px',
          border: `3px solid ${GLOBAL_SCROLLBAR_TRACK_COLOR}`,
        },
        '*::-webkit-scrollbar-track': {
          backgroundColor: GLOBAL_SCROLLBAR_TRACK_COLOR,
        },
      },
    },
  },
});

export default theme;
